"use client"
import { useEffect, useRef } from 'react'

const useClickOutside = <T extends HTMLElement>(cb: () => void) => {
  const elementRef = useRef<T>(null)
  useEffect(() => {
    const clickOutsideListener: EventListener = event => {
      if (
        !elementRef.current ||
        elementRef.current.contains(event.target as Node)
      ) {
        return
      }
      cb()
    }
    document.addEventListener('mousedown', clickOutsideListener)
    document.addEventListener('touchstart', clickOutsideListener)

    return () => {
      document.removeEventListener('mousedown', clickOutsideListener)
      document.removeEventListener('touchstart', clickOutsideListener)
    }
  }, [cb])

  return elementRef
}

export default useClickOutside
